import { render } from "./DashProfileCard.vue?vue&type=template&id=9f9070e6"
import script from "./DashProfileCard.vue?vue&type=script&lang=js"
export * from "./DashProfileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__